import React from "react";
import { Link } from "react-router-dom";

const RecentBlogs = React.memo(({ recentPosts }) => {
  return (
    <div className="mt-[54px]">
      <h1 className="font-semibold text-22 text-white">Recent Blogs</h1>
      <div className="mt-8">
        {recentPosts.map((post) => (
          <Link
            key={post.id}
            to={`/blog/${post.slug}`}
            className="flex gap-2 sm:gap-[25px] items-center group mb-6"
          >
            <div className="w-20 h-[90px] rounded-md overflow-hidden bg-red-100">
              <img
                src={post.image}
                alt={post.title}
                className="object-cover w-full h-full transition-all duration-300 group-hover:scale-110"
              />
            </div>
            <div className="flex-1">
              <p className="text-sm text-paragraph">{post.date}</p>
              <p className="text-paragraph font-semibold mt-1.5 transition-all duration-300 group-hover:underline">
                {post.title}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
});

RecentBlogs.displayName = 'RecentBlogs';

export default RecentBlogs;
